import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import requester from '../../lib/requester';
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import moment from 'moment';
import _ from 'lodash';
import ReactExport from 'react-export-excel-hot-fix';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import Modal from '../../component/modal';
import XLSX from 'xlsx';

class ReportBalanceClaim extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Param_Principal: '',
			Param_Lov_Principal: [],
			Param_SubmitFrom: new Date(),
			Param_SubmitTo: new Date(),
			Param_ClaimBalanceAmount: 0,
			dataTable: [],
			isExport: false,
			isLoading: false,
		};
	}

	componentDidMount = () => {
		this.getPrincipal();
	};

	handleSubmittedDateFrom = (date) => {
		this.setState({ Param_SubmitFrom: date });
	};

	handleSubmittedDateTo = (date) => {
		this.setState({ Param_SubmitTo: date });
	};

	getPrincipal = async () => {
		let url = '/api/traces/v1/general/list-principal';
		requester.getTraces(url, {
			success: function (response) {
				this.setState({ Param_Lov_Principal: response.data.data });
			}.bind(this),
			error: function (e) {
				console.log(e);
			},
		});
	};

	handleExport = () => {
		const data = this.state.dataTable;
		if (data.length > 1) {
			const workBook = XLSX.utils.book_new(); // create a new blank book
			const workSheet = XLSX.utils.json_to_sheet(this.state.dataTable);
			XLSX.utils.book_append_sheet(workBook, workSheet, 'Sheet1'); // add the worksheet to the book
			XLSX.writeFile(workBook, 'Traces Claim Balance.xlsx');
		} else {
			alert('No data to be export !');
		}
	};

	handleSearch = () => {
		this.setState({ isExport: false });
		let app = this;
		window.setTimeout(() => {
			app.getList();
		}, 200);
	};

	getList = () => {
		let { Param_Principal, Param_SubmitFrom, Param_SubmitTo, Param_ClaimBalanceAmount, isExport } =
			this.state;
		let url = '/api/traces/v1/collection/report-balance';
		let param = {
			principal_id: Param_Principal,
			start_claim_date: Param_SubmitFrom,
			end_claim_date: Param_SubmitTo,
			claim_balance_amount: Param_ClaimBalanceAmount
				? Param_ClaimBalanceAmount
				: 0,
			isExport: isExport || false,
		};
		this.setState({ isLoading: true });
		requester.postTraces(url, param, {
			success: function (response) {
				let { data } = response.data;
				this.setState({ isLoading: false, dataTable: data });
				if (isExport) {
					let url2 = data.fullurl;
					window.open(url2);
				}
			}.bind(this),
			error: function (e) {
				this.setState({ isLoading: false });
				console.log(e.message);
			}.bind(this),
		});
	};

	handleChangePrincipal = (e) => {
		let value = e.target.value;
		this.setState({ Param_Principal: value });
	};

	handleChangePrincipal = (e) => {
		let value = e.target.value;
		this.setState({ Param_Principal: value });
	};

	renderFilter = () => {
		return (
			<div className='row'>
				<div className='col-md-12'>
					<div className='card'>
						<div className='card-body'>
							<div className='row'>
								<div className='col-md-3'>
									<div className=''>
										<label className=''>Principal</label>
										<select
											className='form-control'
											onChange={this.handleChangePrincipal.bind(this)}
										>
											<option value={''}>- Select Principal -</option>
											{this.state.Param_Lov_Principal.map((item, index) => (
												<option value={item.org_id}>{item.org_name}</option>
											))}
										</select>
									</div>
								</div>
								<div className='col-md-3'>
									<div className=''>
										<label>Claim Date (From)</label>
										<div className='customDatePickerWidth'>
											<DatePicker
												placeholder='Submitted Date from'
												selected={this.state.Param_SubmitFrom}
												dateFormat='d-MMM-yyyy'
												className='form-control myDatePicker'
												popperPlacement='bottom-end'
												onChange={this.handleSubmittedDateFrom}
											/>
										</div>
									</div>
								</div>
								<div className='col-md-3'>
									<div className=''>
										<label>Claim Date (To)</label>
										<div className='customDatePickerWidth'>
											<DatePicker
												placeholder='Submitted Date from'
												selected={this.state.Param_SubmitTo}
												dateFormat='d-MMM-yyyy'
												className='form-control myDatePicker'
												popperPlacement='bottom-end'
												onChange={this.handleSubmittedDateTo}
											/>
										</div>
									</div>
								</div>
								<div className='col-md-3'>
									<div className=''>
										<label>Claim Balance Amount</label>
										<select
											className='form-control'
											onChange={(e) =>
												this.setState({ Param_ClaimBalanceAmount: e.target.value })
											}
										>
											<option value='0'>{'Claim Balance = 0'}</option>
											<option value='1'>{'Claim Balance > 0'}</option>
										</select>
									</div>
								</div>
								<div className='col-md-12 mt-2'>
									<div className=''>
										<button
											className='btn btn-primary btn-block'
											onClick={this.handleSearch.bind(this)}
										>
											<i className='fa fa-search'></i> Search
										</button>
										{/* <button className="btn btn-success btn-block" onClick={this.handleExport.bind(this)}><i className="fa fa-file-excel"></i> Export</button> */}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};

	handleDetail = (row) => {
		let { Claim_ID } = row.row;
		this.props.history.push('/admin/reportprogram/balance/' + Claim_ID);
	};

	renderTable = () => {
		const data = {
			columns: [
				{
					Header: 'CLAIM NO',
					accessor: 'Claim_Number',
					filterable: true,
				},
				{
					Header: 'CLAIM DATE',
					accessor: 'Claim_Date',
					filterable: true,
					Cell: (row) => (
						<span>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? moment(new Date(row.value)).format('DD-MMM-YYYY')
									: ''}
							</span>
						</span>
					),
				},
				{
					Header: 'RECEIPT NO',
					accessor: 'Receipt_Number',
					filterable: true,
				},
				{
					Header: 'CUSTOMER NAME',
					accessor: 'Customer_Name',
					filterable: true,
				},
				{
					Header: 'PRINCIPAL NAME',
					accessor: 'Principal_Name',
					filterable: true,
				},
				{
					Header: 'PROGRAM DESCRIPTION',
					accessor: 'Program_Description',
					filterable: true,
				},
				{
					Header: 'DPP',
					accessor: 'DPP',
					filterable: true,
					Cell: (row) => (
						<div style={{ textAlign: 'right' }}>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? row.value.toLocaleString('en-US', {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
									  })
									: ''}
							</span>
						</div>
					),
				},
				{
					Header: 'PPN',
					accessor: 'PPN',
					filterable: true,
					Cell: (row) => (
						<div style={{ textAlign: 'right' }}>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? row.value.toLocaleString('en-US', {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
									  })
									: ''}
							</span>
						</div>
					),
				},
				{
					Header: 'PPH',
					accessor: 'PPH',
					filterable: true,
					Cell: (row) => (
						<div style={{ textAlign: 'right' }}>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? row.value.toLocaleString('en-US', {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
									  })
									: ''}
							</span>
						</div>
					),
				},
				{
					Header: 'TOTAL CLAIM',
					accessor: 'Total_Claim',
					filterable: true,
					Cell: (row) => (
						<div style={{ textAlign: 'right' }}>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? row.value.toLocaleString('en-US', {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
									  })
									: ''}
							</span>
						</div>
					),
				},
				{
					Header: 'AMOUNT APPLIED',
					accessor: 'Amount_Applied',
					filterable: true,
					Cell: (row) => (
						<div style={{ textAlign: 'right' }}>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? row.value.toLocaleString('en-US', {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
									  })
									: ''}
							</span>
						</div>
					),
				},
				{
					Header: 'CLAIM BALANCE',
					accessor: 'Claim_Balance',
					filterable: true,
					Cell: (row) => (
						<div style={{ textAlign: 'right' }}>
							<span>
								{row.value !== null && row.value !== '' && row.value !== 'null'
									? row.value.toLocaleString('en-US', {
											minimumFractionDigits: 2,
											maximumFractionDigits: 2,
									  })
									: ''}
							</span>
						</div>
					),
				},
				{
					Header: 'STATUS',
					accessor: 'Status',
					filterable: true,
				},
				{
					Header: '#',
					accessor: 'Claim_ID',
					filterable: true,
					Cell: (row) => (
						<div style={{ textAlign: 'right' }}>
							<button
								className='btn btn-primary'
								onClick={(e) => {
									this.handleDetail(row);
								}}
							>
								<i className='fa fa-eye'></i>
							</button>
						</div>
					),
				},
			],
			rows: this.state.dataTable,
		};
		return (
			<div className='row'>
				<div className='col-12 text-right'>
					<button
						className='btn btn-success'
						onClick={this.handleExport.bind(this)}
					>
						<i className='fa fa-file-excel'></i> Export
					</button>
					<div className='col-12 mt-2 px-0'>
						<ReactTable
							className='fullWidth'
							data={data.rows}
							columns={data.columns}
							defaultPageSize={10}
							defaultFilterMethod={(filter, row, column) => {
								let columnes = row[filter.id];
								return columnes
									? columnes.toLowerCase().includes(filter.value.toLowerCase())
									: '';
							}}
						/>
					</div>
				</div>
			</div>
		);
	};

	render() {
		return (
			<div>
				<section className='content'>
					<div className='container-fluid'>
						<div className='row ml-1'>
							<div className='col-lg-12'>
								<div className='card card-info'>
									<div className='card-header'>Report Balance Claim</div>
									<div className='card-body'>
										{this.renderFilter()}
										<div className='clearfix'>&nbsp;</div>
										<div className='row'>
											<div className='col-lg-12'>{this.renderTable()}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<Loader fullPage loading={this.state.isLoading} />
			</div>
		);
	}
}

export default ReportBalanceClaim;
